const trackingConstants = {
    CLICK: {
        event_type: '',
        product_list_name: [''],
        imp_origin_system: [''],
        product_id: [''],
        product_article_id: [''],
        product_name: [''],
        product_category: [''],
        product_color_code: [''],
        product_position: [''],
        product_view_type: '',
        product_segment_type: '',
        product_segment_id: '',
        product_brand: [''],
    },
    IMPRESSION: {
        event_type: '',
        imp_list_name: '',
        imp_origin_system: [],
        imp_segment_type: [],
        imp_segment_id: '',
        imp_name: [''],
        imp_id: [''],
        imp_position: [''],
        imp_color: [''],
        imp_category: [''],
        imp_brand: [''],
    },
};
export default trackingConstants;
//# sourceMappingURL=trackingConstants.js.map